<template>
    <div class="main_container">

        <!--列表-->
        <my-table  :items="tableDataDetail" :headers="tableHeaderDetail" :oprateBtns="oprateBtns" :selectShow="false" :oprateOption="oprateOption"  :listLoading="listLoadingDetail"   :totalNum="TotalNumDetail" :pageSize="detileParams.pageSize" @getTableData="getTableDataDetail">
            <template slot-scope="{props}" slot="caozuo">
               <span class="caozuo_span" @click="getDetailPage(props.row)">查看</span>
            </template>
            <template slot-scope="{props}" slot="CheckStatusText">
                <span>{{props.row.CheckStatusText}}</span>
            </template>
        </my-table>

    </div>

</template>
<script>
import MyTable from '@/components/Table'
export default {
    components: {
        MyTable
    },
    data(){
        return{
            commitTypeList: [{
                value: '0',
                label: '全部'
            }, {
                value: '1',
                label: '互联网资源'
            }, {
                value: '2',
                label: '联合比对库资源'
            }],
            tableData: [],
            border:true,
            listLoading: true,
            oprateBtns: [
                // {text: '查看', method: 'viewFn',class: 'view_btn'},
                {text: '编辑', method: 'editFn'},
            ],
            tableHeaderDetail:[
                {prop: 'RequesterName', label: '申请人姓名',},
                {prop: 'RequesterOrganisation', label: '所在单位'},
                {prop: 'ArticleName', label: '待撤文章题目'},
                {prop: 'Author', label: '待撤文章作者'},//
                // {prop: 'Publication', label: '发表刊物/比对库'},
                // {prop: 'PublishTime', label: '发表时间'},
                {prop: 'CheckStatusText', label: '状态',show:'template'},
                {prop: 'caozuo', label: '操作',show: 'template'},
            ],
            tableDataDetail:[],
            listLoadingDetail:true,
            TotalNumDetail:1,
            commitText: '',
            oprateOption:{
                hasOprate:false,
                oprateName:"操作",
                width:""
            },
            detileParams:{
                commitType: '0', // 1 互联网资源 2 联合比对库资源
                checkStatus:"",
                requesterName:"",
                requesterPhoneNum:sessionStorage.getItem("userName"),
                requesterOrganisation:"",
                articleName:"",
                author:"",
                publication:"",
                // publishTime:"",
                publishTimeBegin:"",
                publishTimeEnd:"",
                order:1,
                pageIndex:1,//第几页
                pageSize:20//每页多少条
            },
        }
    },
    created(){
        this.getTableDataDetail();
    },
    methods: {
        viewDetail(){
            this.$router.push('viewRecord');
        },
        getDetailPage(row){
            // console.log('row==========>', row)
            this.$router.push({
                name: 'viewRecord',
                params: {
                    id: row.ID,
                    pageType: 1,
                    type: row.CommitType,
                    row: row
                }
            })
        },
        handleSelectionChange(){

        },
        commitGetBysearchParam(){

        },
        getTableDataDetail(p){
            this.listLoadingDetail = true;
            var _this = this;
            if (!p){
                p = 1;
            }
            if (!!p) {
                this.detileParams.pageIndex=p;
            }
            _this.$api.commitGetBysearchParam(this.detileParams).then(res => {
                // console.log("datalist",res.data);
                if(res.data&&res.data.result){
                    this.listLoadingDetail = false
                    var tableData = res.data.info.SearchList || [];
                    _this.TotalNumDetail = res.data.info.TotalNum;
                    tableData.forEach((item) => {
                        if(item.CheckStatus==0){
                            // item.CheckStatusText='待审核'
                            item.CheckStatusText='处理中'
                        }else if(item.CheckStatus==-2){
                            item.CheckStatusText='撤除失败'
                        }else if(item.CheckStatus==-1){
                            item.CheckStatusText='审核未通过'
                        }else if(item.CheckStatus==1){
                            item.CheckStatusText='处理中'
                        }else if(item.CheckStatus==2){
                            item.CheckStatusText='撤除成功 '
                        }
                    })
                    _this.tableDataDetail=tableData;
                }else{
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                }

            })
        },


    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// applyRecord.vue?f06f4a90